var _style, _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.3 24.5",
    style: {
      enableBackground: "new 0 0 23.3 24.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{clip-path:url(#SVGID_00000021119309502018190800000012685944787049095604_);}\r\n\t.st2{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 23.3,
    height: 24.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108990756536645969120000018401419485239355520_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000108990756536645969120000018401419485239355520_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.8,24.5c-3.2,0-6.4,0-9.6,0c-1.9,0-2.2-0.3-2.2-2.3c0-1.6,0-3.2,0-4.8c0-1,0.2-1.8,1.3-1.8 c1.1,0,1.3,0.8,1.3,1.7c0,1.1,0,2.3,0,3.4c0,0.8,0.3,1.1,1.1,1c5.3,0,10.7,0,16,0c0.8,0,1.1-0.3,1-1.1c0-1.2,0-2.4,0-3.5 c0-0.9,0.3-1.5,1.3-1.5c1,0,1.3,0.7,1.3,1.5c0,1.8,0,3.6,0,5.4c0.1,1.4-0.6,1.9-1.9,1.9C18.2,24.5,15,24.5,11.8,24.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.4,14.3V4.3c0-0.7,0-1.3,0-2c0-1-0.2-2.3,1.3-2.3c1.5,0,1.3,1.2,1.3,2.3c0,3.5,0,7,0,10.4v1.7 c0.9-0.4,1.3-1,1.8-1.5c0.7-0.6,1.3-0.8,2-0.1c0.7,0.7,0.5,1.4-0.2,2c-1.3,1.3-2.6,2.6-3.9,3.9c-0.7,0.7-1.4,0.7-2.1,0 c-1.3-1.3-2.6-2.6-3.9-3.9c-0.6-0.6-0.8-1.3-0.2-2c0.7-0.7,1.4-0.5,2,0.1c0.5,0.5,0.9,1.1,1.3,1.7L10.4,14.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.2c87ffbf2e2ee9c563f18fb84e0de813.svg";
export { ForwardRef as ReactComponent };